import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Badge } from '@aimsos/ui';

import { TRAIT_USES } from '../../constants/intelligence.js';

/**
 * Where a trait is used: How to approach, Next Best Action, Drafts — in that
 * order whatever order the payload sends — or a plain line when it is used
 * nowhere yet (CT-5715).
 */
const TraitUsedIn = memo(function TraitUsedIn({ usedIn = [] }) {
  const { t } = useTranslation('unified-profiles');
  const uses = TRAIT_USES.filter((use) => usedIn.includes(use));

  if (!uses.length) {
    return <p className="text-sm text-content-secondary">{t('intelligence.traits.detail.notUsed')}</p>;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {uses.map((use) => (
        <Badge key={use} variant="success" size="small">
          {t(`intelligence.traits.uses.${use}`)}
        </Badge>
      ))}
    </div>
  );
});

export default TraitUsedIn;
